import React from 'react'
import './IntroMain.css';
import WhyCardList from '../../UI/Intro/WhyCardList';
import Tabs from '../../UI/Intro/tabs/tabs';
import greenBg from '../../assets/greenbg.png';
import HowCard from './howCard/howCard';
import Pricing from './PricingCards/Pricing';

const IntroMain = () => {
  return (
    <div className='main-outer'>
      <section >
        <div className='section-header'>
          <p className='section-header-title'>How Does CloudLab Work?</p>
          <div className='section-content'>
            <HowCard />
          </div>
        </div>
        <div className='section-header'>
          <p className='section-header-title'>Why Choose CloudLab?</p>
          <div className='section-content'>
            <div className="why-card-bg-wrapper">
              <WhyCardList />
            </div>
          </div>
        </div>
        <div className='section-header'>
          <p className='section-header-title'>Discover the Tools You Can Use</p>
          <div className='section-content'>
            <div className='tabs-bg-wrapper' style={{ backgroundImage: `url(${greenBg})` }}>
              <Tabs />
            </div>
          </div>
        </div>
        {/* <div className='section-header'>
          <p className='section-header-title'>What Our Users Are Saying</p>
          <div className='section-content'>
            <div className='intro-card-wall'>
              <CardsWall />
            </div>
          </div>
        </div> */}
        <div className='section-header'>
          <p className='section-header-title-green'>Flexible Pricing for Every Need
            <br />
            <p className='section-subheader-title-green'>Tiered pricing plans</p>
          </p>
          <div className='section-content'>
            <div className='intro-card-wall'>
              <div className='tabs-bg-wrapper' style={{ backgroundImage: `url(${greenBg})` }}>
                <Pricing />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default IntroMain